export default "__VITE_ASSET__62bf9569__"